import { AnalysisStatus } from "../../lib/enums";

export const HTTP_TOO_MANY_REQUEST_STATUS_CODE = 429;

export const SECTIONS = {
  FILE_ANALYSIS: {
    SAMPLE_DETAILS: "sample_details/",
    RELATIONSHIPS_GRAPH: "force_graph/",
    MITRE: "mitre_attack/",
    HOW_WE_CAUGHT_THIS: "how_we_caught_this/",
    NETWORK_REFERENCES: "network_references/",
    ATTRIBUTION_DATA: "attribution-data/",
    ANALYSIS_RESULTS: "analysis_results/"
  },
  TI_CORE: {
    CLASSIFICATION: "ticore/classification/",
    YARA: "ticore/classification/yara/",
    INDICATORS: "ticore/indicators/",
    INTERESTING_STRINGS: "ticore/interesting_strings/",
    FILE_INFO: "ticore/info/file/"
  },
  AUXILIARY_ANALYSIS: {
    INDEX: "rl_auxiliary_analysis/"
  },
  THREAT_INTELLIGENCE: {
    MULTISCANNER: "ticloud/",
    RHA: "rha/?threat_status=",
    TLSH: "tlsh/",
    SSDEEP: "ssdeep/"
  },
  DYNAMIC_ANALYSIS: {
    CLOUD_SANDBOX: "rl_dynamic_analysis/",
    CLOUD_SANDBOX_NETWORK: "rl_dynamic_analysis/network_analysis/",
    AUXILIARY_ANALYSIS: "rl_auxiliary_analysis",
    AUXILIARY_ANALYSIS_NETWORK: "rl_auxiliary_analysis/network_analysis/",
    CAPE: "cape/",
    CAPE_NETWORK: "cape/network_analysis/",
    CISCO_SMA: "cisco_secure_malware_analytics/",
    CISCO_SMA_NETWORK: "cisco_secure_malware_analytics/networking/",
    CUCKOO: "cuckoo/",
    CUCKOO_NETWORK: "cuckoo/network_analysis/",
    FIREEYE: "fireeye/",
    FIREEYE_NETWORK: "fireeye/network_analysis/",
    JOE: "joe/",
    JOE_NETWORK: "joe/network_analysis/",
    VMRAY: "vmray_tcbase/",
    VMRAY_NETWORK: "vmray_tcbase/networking/"
  },
  SOURCES: {
    TI_CLOUD: "sources/ticloud/"
  },
  EXTRACTED_FILES: {
    INDEX: "extracted-files/"
  }
};

export const COMPONENT_IDS = {
  SAMPLE_INFORMATION: "sample-information",
  SAMPLE_DESCRIPTION: "sample-description",
  RELATIONSHIP_GRAPH: "relationship-graph",
  MITRE: "mitre-attack",
  ATTRIBUTION_DATA: "threat-intelligence",
  NETWORK_REFERENCES: "network-references",
  STATIC_ANALYSIS_INSIGHTS: "static-analysis-insights",
  DYNAMIC_ANALYSIS_INSIGHTS: "dynamic-analysis-insights",
  YARA_MATCHES: "yara-matches",
  EMAIL: "email",
  LLM_SUMMARY: "llm-summary",
  SOURCES: "sources"
};

const { PROCESSING, QUEUED, UPLOADING, ANALYZING, REANALYZING } =
  AnalysisStatus;
export const ANALYZING_CONSTS: Array<string> = [
  PROCESSING,
  QUEUED,
  UPLOADING,
  ANALYZING,
  REANALYZING
];
